/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'


import { render, staticRenderFns } from "./pay-all-popup.vue.js?vue&type=template&id=3905a84a&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pay-all-popup.vue?vue&type=template&id=3905a84a&scoped=true"
import script from "./pay-all-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pay-all-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./pay-all-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pay-all-popup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pay-all-popup.vue.postcss?vue&type=style&index=0&id=3905a84a&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pay-all-popup.vue?vue&type=style&index=0&id=3905a84a&prod&lang=postcss&module=true"
import style1 from "./pay-all-popup.vue.css?vue&type=style&index=1&id=3905a84a&prod&scoped=true&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pay-all-popup.vue?vue&type=style&index=1&id=3905a84a&prod&scoped=true&lang=css"
import style2 from "./pay-all-popup.vue.css?vue&type=style&index=2&id=3905a84a&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pay-all-popup.vue?vue&type=style&index=2&id=3905a84a&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3905a84a",
  null
  
)

export default component.exports
installComponents(component, {VanButton})
